import React from 'react'

const HomeFaq = () => {
    return (
        <>



        </>
    )
}

export default HomeFaq